import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, TextField, Box, ToggleButtonGroup, ToggleButton } from '@mui/material'
import { useState } from 'react'

export type ContactInfo =
  | { firstName: string; lastName: string; isCommercial: false }
  | { entityName: string; isCommercial: true }

type ContactType = 'individual' | 'entity'

interface EarnestMoneyContactDialogProps {
  open: boolean
  onSubmit: (contactInfo: ContactInfo) => void
  onClose: () => void
}

export function EarnestMoneyContactDialog({ open, onSubmit, onClose }: EarnestMoneyContactDialogProps) {
  const [contactType, setContactType] = useState<ContactType>('individual')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [entityName, setEntityName] = useState('')

  const isValid = contactType === 'individual'
    ? firstName.trim() !== '' && lastName.trim() !== ''
    : entityName.trim() !== ''

  const handleSubmit = () => {
    if (!isValid) return
    if (contactType === 'individual') {
      onSubmit({ firstName: firstName.trim(), lastName: lastName.trim(), isCommercial: false })
    } else {
      onSubmit({ entityName: entityName.trim(), isCommercial: true })
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Contact Information Required</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Please provide your name or entity name to proceed with the earnest money payment.
        </DialogContentText>

        <ToggleButtonGroup
          value={contactType}
          exclusive
          onChange={(_, value) => { if (value) setContactType(value) }}
          sx={{ mb: 2 }}
          fullWidth
        >
          <ToggleButton value="individual">Individual</ToggleButton>
          <ToggleButton value="entity">Entity / Organization</ToggleButton>
        </ToggleButtonGroup>

        {contactType === 'individual' ? (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
              fullWidth
              autoFocus
            />
            <TextField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
              fullWidth
            />
          </Box>
        ) : (
          <TextField
            label="Entity / Organization Name"
            value={entityName}
            onChange={(e) => setEntityName(e.target.value)}
            required
            fullWidth
            autoFocus
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="rounded" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" onClick={handleSubmit} disabled={!isValid}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}
